import authFetch from "../authFetch";
async function authFileOpen(url) {
  if (!url) return;
  if (!url.startsWith("/api/file")) { window.open(url, "_blank"); return; }
  try {
    const r = await authFetch(url);
    if (!r.ok) { alert("Unable to access file — please log in again."); return; }
    const blob = await r.blob();
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  } catch { alert("Failed to load file."); }
}
async function authFileDownload(url, fileName) {
  if (!url) return;
  if (!url.startsWith("/api/file")) { window.open(url, "_blank"); return; }
  try {
    const r = await authFetch(url);
    if (!r.ok) { alert("Unable to access file — please log in again."); return; }
    const blob = await r.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl; a.download = fileName || "download";
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
  } catch { alert("Failed to download file."); }
}
async function uploadFileToStorage(file, wsKey){
  if(!file)return null;
  try{
    const base64=await new Promise((resolve,reject)=>{const r=new FileReader();r.onload=()=>resolve(r.result);r.onerror=reject;r.readAsDataURL(file);});
    const res=await authFetch("/api/upload",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({fileName:file.name,fileData:base64,contentType:file.type,wsKey:wsKey||""})});
    const d=await res.json();
    return d.ok?d.url:null;
  }catch(e){console.error("[uploadFileToStorage]",e);return null;}
}
export { authFileOpen, authFileDownload, uploadFileToStorage };
